// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3tiZH","header":"Messages_header__3vbXI"};